export default "__VITE_ASSET__Bsfl9Kmc__"